import { subscribeOutOfStockProduct } from 'store/ProductCatalog/actions';
import {
  subscribeOutOfStockСardProduct,
  hideOutOfStockСardForm,
} from 'store/ProductDetails/outofstock/actions';
import { COMMON_PAGE_LOADED } from 'store/common/settings/constants';
import { REQUEST_CATALOG_PRODUCTS_APPLIED } from 'store/ProductCatalog/constants';

import { LOCAL_STORAGE_DATA_KEY } from '../ProductCatalog/outofstock/constants';

export default ({ dispatch, getState }) =>
  (next) =>
  (action) => {
    const state = getState();
    const bodyData = state.body || {};

    const changeOutOfStockProducts = () => {
      const storage = (window || {}).localStorage;
      const outofstockList = JSON.parse(storage.getItem(LOCAL_STORAGE_DATA_KEY)) || [];
      const { products, isOutOfStock, productId } = bodyData;
      if (storage) {
        if (products && products.length !== 0) {
          outofstockList.forEach((item) => dispatch(subscribeOutOfStockProduct(item)));
        } else if (isOutOfStock && outofstockList.some((item) => item === productId)) {
          dispatch(hideOutOfStockСardForm());
          dispatch(subscribeOutOfStockСardProduct());
        }
      }
    };

    switch (action.type) {
      case COMMON_PAGE_LOADED:
        changeOutOfStockProducts();
        break;
      case REQUEST_CATALOG_PRODUCTS_APPLIED:
        changeOutOfStockProducts();
        break;
      default:
        break;
    }
    return next(action);
  };
